import { lazy } from 'react'
import { defineFeature } from '@/app/features/types'

const VerificationPage = lazy(() => import('./VerificationPage'))

export const feature = defineFeature({
  id: 'integration-verification',
  routes: [
    {
      path: '/integration/verification/*',
      permission: 'integration:read',
      Component: VerificationPage,
    },
  ],
})
